<template>
  <div ref="header-container" class="header-container">
    <h2 v-html="displayedMessage"></h2>
  </div>
</template>

<script>
import gsap from 'gsap'

import consoleLog from '@/lib/consoleLog.js'

export default {
  name: 'HeaderText',
  props: {
    message: String,
  },
  data() {
    return {
      displayedMessage: '',
    }
  },
  mounted() {
    this.displayedMessage = this.message
  },
  watch: {
    message() {
      consoleLog('header message changed to:', this.message)

      if (this.message == 'Loading...') {
        this.displayedMessage = 'Loading...'
      } else {
        const elem = this.$refs['header-container']
        const tl = gsap.timeline({ repeat: 0 })
        tl.to(elem, {
          opacity: 0,
          duration: 0.5,
          onComplete: () => {
            this.displayedMessage = this.message
          },
        })
        tl.to(elem, { opacity: 1, duration: 0.5 })
      }
    },
  },
}
</script>

<style scoped>
.header-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px 16px 8px 16px;
}

.header-container h2 {
  margin: 0;
  transition: opacity 0.5s;
  text-align: center;
  font-family: 'Inter Black';
  color: #666666;
  font-size: 1.5rem;
}

@media (max-width: 768px) {
  .header-container h2 {
    font-size: 1.2rem;
  }
}
</style>
